import { createSlice } from "@reduxjs/toolkit";
import qs from "query-string";

const initialState = {
  dataFilter: {
    bgMain: false,
    bgSoute: false,
    nbrBgSoute: 0,
    adult: 1,
    enf: 0,
    baby: 0,
    escale: null,
    escaleNight: false,
    price: [0, 14000],
    selectedCompanies: [],
    companies: [
      "Air algérie",
      "Air France",
      "Emarates",
      "Qatar AirLines",
      "USA",
      "Turkish Airlines",
    ],
    searchterm: "",
    selectAll: true,
  },
  redirectBool: false,
  url: 1,
  nbrBag: "",
  handBG: "",
  holdBg: "",
};

export const filterSlice = createSlice({
  name: "VolFilter",
  initialState,
  reducers: {
    volFilter: (state, action) => {
      state.VolFilter = action.payload.VolFilter;
    },
    adult: (state, action) => {
      state.dataFilter.adult = action.payload;
    },
    enf: (state, action) => {
      state.dataFilter.enf = action.payload;
    },
    baby: (state, action) => {
      state.dataFilter.baby = action.payload;
    },
    advancedFilter: (state, action) => {
      state.dataFilter = action.payload;
      state.nbrBag = state.dataFilter.bgSoute ? state.dataFilter.nbrBgSoute : 0;

      state.handBG = state.dataFilter.bgMain ? 1 : 0;
      state.holdBg = state.nbrBag;

      if (state.dataFilter.adult > 1) {
        state.nbrBag = "0";
        for (let index = 0; index < state.dataFilter.adult - 1; index++) {
          state.nbrBag = state.nbrBag + "," + "0";
        }
        state.nbrBag = state.nbrBag.substring(0, state.nbrBag.length - 2);
        state.handBG = state.dataFilter.bgMain ? "1" : "0";
        state.handBG = state.handBG.toString() + "," + state.nbrBag;

        state.holdBG = state.dataFilter.bgSoute
          ? state.dataFilter.nbrBgSoute
          : "0";
        state.holdBg = state.holdBG.toString() + "," + state.nbrBag;
      } else if (parseInt(state.dataFilter.adult) <= 1) {
        state.nbrBag = "";
        state.handBG = state.dataFilter.bgMain ? 1 : 0;
        state.holdBg = state.dataFilter.bgSoute
          ? state.dataFilter.nbrBgSoute
          : 0;
      }
      state.url = `&adults=${state.dataFilter.adult}&children=${state.dataFilter.enf}&infants=${state.dataFilter.baby}&price_from=${state.dataFilter.price[0]}&price_to=${state.dataFilter.price[1]}&max_stopovers=${state.dataFilter.escale}&adult_hand_bag=${state.handBG}&adult_hold_bag=${state.holdBg}`;
      state.nbrBag = "";
    },
    redirect: (state, action) => {
      state.redirectBool = action.payload;
    },
  },
});

export const { volFilter, advancedFilter, redirect, adult, enf, baby } =
  filterSlice.actions;

export default filterSlice.reducer;
